/**
 * LoginContainer
 *
 * Login screen shown when the user is not authenticated. Owns the password
 * input locally; everything else (username, auth state, errors) comes from
 * AuthContext.
 */

import { useState } from 'react';
import { useSocketContext } from '@swtorbit/shared-react-hooks';
import { useAuthContext } from '../../contexts/AuthContext';

import { logoSwtorbit } from '@swtorbit/shared-assets';

export function LoginContainer() {
  const { username, isAuthenticating, loginError, setUsername, login } = useAuthContext();
  const { isConnected } = useSocketContext();
  const [password, setPassword] = useState('');

  if (isAuthenticating) {
    return (
      <div className="page justify-content-center align-items-center gap-base">
        <h1>Admin Dashboard</h1>
        <div className="d-flex flex-column gap-base">
          <p>Checking authentication...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page justify-content-center align-items-center">
            <img
        src={logoSwtorbit}
        alt="SWTORBIT"
        className="anim anim--fade-in"
        style={{ width: '20rem', height: 'auto', marginBottom: '1rem' }}
      />
      <h1 className="text-center text-white text-uppercase ff-display">Admin</h1>
      <div className="d-flex flex-column gap-base mt-lg bg-space bg-o-50 border-md border-blue-light rounded-sm p-lg gap-sm glow-primary">
        <input
          className="input"
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          onKeyUp={(e) => e.key === 'Enter' && document.getElementById('password-input')?.focus()}
        />
        <input
          className="input"
          id="password-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyUp={(e) => e.key === 'Enter' && login(username, password)}
        />
        {loginError && (
          <div className="field__error">{loginError}</div>
        )}
        <button
          className="btn btn--fancy btn--cyan mx-auto mt-lg px-lg py-xs text-uppercase fw-bold"
          onClick={() => login(username, password)}
          disabled={!isConnected || !username || !password}
        >
          {isConnected ? 'Login' : 'Connecting...'}
        </button>
      </div>
    </div>
  );
}
